import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';
import { 
  setSearchTerm, 
  setSelectedBrand, 
  setSelectedCategory 
} from '@/store/slices/dashboardSlice';
import { fetchDashboardData, fetchMoreBrands, fetchMoreCategories } from '@/store/sagas/dashboardSaga';
import { Brand, Category } from "@/types/dashboard";

export function SearchFilters() {
  const dispatch = useAppDispatch();
  const brands = useAppSelector(state => state.dashboard.brands);
  const categories = useAppSelector(state => state.dashboard.categories);
  const [brandsPage, setBrandsPage] = useState(1);
  const [categoriesPage, setCategoriesPage] = useState(1);

  // useEffect(() => {
  //   dispatch(fetchMoreBrands({ page: 1 }));
  //   dispatch(fetchMoreCategories({ page: 1 }));
  // }, [dispatch]);

  const handleSearchChange = (value: string) => {
    dispatch(setSearchTerm(value));
    dispatch(fetchDashboardData());
  };

  const handleBrandChange = (value: string) => {
    dispatch(setSelectedBrand(value));
    dispatch(fetchDashboardData());
  };

  const handleCategoryChange = (value: string) => {
    dispatch(setSelectedCategory(value));
    dispatch(fetchDashboardData());
  };

  const handleBrandScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop === clientHeight) {
      setBrandsPage(prev => {
        const nextPage = prev + 1;
        dispatch(fetchMoreBrands({ page: nextPage }));
        return nextPage;
      });
    }
  };

  const handleCategoryScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop === clientHeight) {
      setCategoriesPage(prev => {
        const nextPage = prev + 1;
        dispatch(fetchMoreCategories({ page: nextPage }));
        return nextPage;
      });
    }
  };

  return (
    <div className="flex items-center gap-4 flex-1">
      <Input
        type="search"
        placeholder="Search products..."
        className="max-w-sm"
        onChange={(e) => handleSearchChange(e.target.value)}
      />
      {/* <Select onValueChange={handleBrandChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select brand" />
        </SelectTrigger>
        <SelectContent onScroll={handleBrandScroll}>
          {brands.map((brand: Brand) => (
            <SelectItem key={brand.id} value={brand.id}>
              {brand.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select onValueChange={handleCategoryChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select category" />
        </SelectTrigger>
        <SelectContent onScroll={handleCategoryScroll}>
          {categories.map((category: Category) => (
            <SelectItem key={category.id} value={category.id}>
              {category.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select> */}
    </div>
  );
}